import React from "react";
import { useSdkContext } from "scmp-sdk/components/contexts";
import { useNewsletterContext } from "scmp-sdk/components/newsletter/newsletter-widget/contexts";
import { getTriggerPoint } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/helpers";

import {
  Button,
  ButtonContainer,
  Container,
  ContentContainer,
  FirstLine,
  InnerContainer,
  MessageContainer,
  SecondLine,
  SignUpLink,
  StyledNewsletterIcon,
} from "./styles";

export type Props = React.DetailsHTMLAttributes<HTMLDivElement>;

export const HomepageThemeFindOutMore: React.FunctionComponent<Props> = ({ ...props }) => {
  const { handleRoutePush, handleTrackGA4 } = useSdkContext();
  const { campaignName, findOutMoreButtonDisplayComponent, variant } = useNewsletterContext();

  const handleSignUpLinkClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    handleTrackGA4({
      action: "click",
      category: "nl",
      customized_parameters: {
        internal_campaign: campaignName ?? "",
        trigger_point: getTriggerPoint(variant),
      },
      subcategory: "entry",
    });
    void handleRoutePush("/newsletters");
  };

  return (
    <Container {...props}>
      <InnerContainer>
        <ContentContainer>
          <StyledNewsletterIcon />
          <MessageContainer>
            <FirstLine>Expand your horizons -</FirstLine>
            <SecondLine>
              Discover and{" "}
              <SignUpLink href="/newsletters" onClick={handleSignUpLinkClick}>
                sign up
              </SignUpLink>{" "}
              for our other newsletters
            </SecondLine>
          </MessageContainer>
        </ContentContainer>
        <ButtonContainer>
          <Button href="/newsletters" onClick={handleSignUpLinkClick}>
            {findOutMoreButtonDisplayComponent ?? "FIND OUT MORE"}
          </Button>
        </ButtonContainer>
      </InnerContainer>
    </Container>
  );
};

HomepageThemeFindOutMore.displayName = "HomepageThemeFindOutMore";
